var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.confidentialTooltip,"variant":"warning"}},[_c('gl-icon',{attrs:{"name":"eye-slash","size":16}}),_vm._v(" "),_c('span',{class:_vm.confidentialTextClass,attrs:{"data-testid":"confidential-badge-text"}},[_vm._v(_vm._s(_vm.__('Confidential')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }